// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content-footer[data-v-d15f9ed8]{position:sticky;bottom:0;z-index:10;background:hsla(0,0%,100%,.8);-webkit-backdrop-filter:blur(5px);backdrop-filter:blur(5px);border-radius:8px}", ""]);
// Exports
module.exports = exports;
